<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="name">
        <span slot="label"><a-tooltip>{{ $t('名称') }}<template
          slot="title">{{ $t('名称') }}</template></a-tooltip> </span>
        <a-input v-model="form.name" style="width: 100%" :maxLength="12" disabled  :placeholder="$t('请输入')+'名称'" />
      </a-form-model-item>
      <a-form-model-item prop="annualAmount">
        <span slot="label"><a-tooltip>{{ $t('年费') }}<template
          slot="title">{{ $t('年费') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.annualAmount" :min="0" :max="999999" :step="0.01" style="width: 100%" :maxLength="4"  :placeholder="$t('请输入')+'服务费'" />
      </a-form-model-item>
      <a-form-model-item prop="goodsMaxNum">
        <span slot="label"><a-tooltip>{{ $t('最大商品数') }}<template slot="title">{{ $t('最大商品数') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.goodsMaxNum" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'最大商品数'"/>
      </a-form-model-item>
      <a-form-model-item prop="rate">
        <span slot="label"><a-tooltip>{{ $t('费率') }}<template
          slot="title">{{ $t('费率') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.rate" :min="0" :max="100" :step="0.01" style="width: 100%" :maxLength="5"  :placeholder="$t('请输入')+'服务费'" />
        <span class="ant-input-suffix">%</span>
      </a-form-model-item>
      <a-form-model-item prop="remark">
        <span slot="label"><a-tooltip>{{ $t('备注') }}<template
          slot="title">{{ $t('备注') }}</template></a-tooltip> </span>
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear/>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getBusinessType, addBusinessType, updateBusinessType} from '@/api/merchant/businessType'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";
import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";


export default {
  name: 'CreateForm',
  props: {},
  components: {
    CustomDictTag,
    LocaleFieldButton,
  },
  data() {
    return {
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        name: null,
        annualAmount: null,
        goodsMaxNum: null,
        rate: null,
        remark: null,
        localeFieldMap: {},
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [{required: true, message: this.$t('名称') + this.$t('不能为空'), trigger: 'blur'}],
        goodsMaxNum: [{required: true, message: this.$t('最大id') + this.$t('不能为空'), trigger: 'blur'}]
      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.cancel()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        annualAmount: null,
        goodsMaxNum: null,
        rate: null,
        remark: null,
        localeFieldMap: {},
      }

    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getBusinessType({"id": id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateBusinessType(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addBusinessType(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
